var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b(),style:({ backgroundColor: _vm.color })},[_c('v-icon',[_vm._v("mdi-paperclip")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }